export default "__VITE_PUBLIC_ASSET__ea002916__"